/* The wholesale range is taken from the variant cards actually rendered on the portal. */
(() => {
  const storageKey = 'rasta-wholesale:checkout-variants:ZAR';
  const parse = (ids) => new Set(Array.from(ids || []).map(String).filter((id) => /^[1-9]\d*$/.test(id)));
  const allowed = (item, ids) => ids.has(String(item.variant_id)) && !item.gift_card && !item.selling_plan_allocation &&
    String(item.properties?._cs_free_gift || '').toLowerCase() !== 'true';
  const validate = (cart) => {
    if (!Array.isArray(cart?.items)) throw new Error('We could not verify your wholesale cart. Please try again.');
    if (cart.currency !== 'ZAR') throw new Error('Select South Africa and use ZAR before continuing with wholesale checkout.');
  };

  window.RastaWholesaleScope = {
    tiers: Object.freeze([
      Object.freeze({ minimum: 1400000, percent: 40 }),
      Object.freeze({ minimum: 2000000, percent: 50 }),
      Object.freeze({ minimum: 4000000, percent: 60 }),
    ]),
    pricing(qualifying, subtotal = qualifying) {
      const tier = this.tiers.filter(tier => qualifying >= tier.minimum).at(-1) || null;
      const nextTier = this.tiers.find(tier => qualifying < tier.minimum) || null;
      const percent = tier?.percent || 0;
      // Round savings down to whole cents so estimates never overstate the discount.
      const savings = Math.floor(subtotal * percent / 100);
      return { tier, nextTier, percent, eligible: percent > 0, savings, total: subtotal - savings };
    },
    allowed,
    remember(ids) {
      try { sessionStorage.setItem(storageKey, JSON.stringify(Array.from(parse(ids)))); return true; }
      catch (_) { return false; }
    },
    read() {
      try { const ids = JSON.parse(sessionStorage.getItem(storageKey) || '[]'); return Array.isArray(ids) ? parse(ids) : new Set(); }
      catch (_) { return new Set(); }
    },
    estimate(cart, ids) {
      if (!cart) return cart;
      const items = (cart.items || []).filter((item) => allowed(item, ids));
      const subtotal = items.reduce((sum, item) => sum + (Number(item.final_line_price ?? item.original_line_price) || 0), 0);
      return { ...cart, items, items_subtotal_price: Math.min(Number(cart.items_subtotal_price ?? subtotal), subtotal) };
    },
    async clean(cart, ids, request, owns = () => true) {
      if (!ids.size) throw new Error('Open the wholesale range first so we can verify the products in your order.');
      validate(cart);
      // Re-read after each removal; never proceed using an unconfirmed update response.
      for (let attempt = 0; attempt < 2; attempt++) {
        const outside = cart.items.filter((item) => !allowed(item, ids) || !owns(item));
        if (!outside.length) return cart;
        if (outside.some((item) => !item.key)) throw new Error('We could not identify a cart item safely. Please reload your cart.');
        const updates = Object.fromEntries(outside.map((item) => [item.key, 0]));
        await request('cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ updates }) });
        cart = await request('cart.js');
        validate(cart);
      }
      if (cart.items.some((item) => !allowed(item, ids) || !owns(item))) throw new Error('Other products are still being added to your cart. Please try wholesale checkout again.');
      return cart;
    },
  };
})();
